export default {
  fetch: async () => ({ isConnected: true })
};
